import { Component, inject } from '@angular/core';

import { RouterLink, RouterOutlet } from '@angular/router';
import { IxApplication, IxApplicationHeader, IxMenu, IxMenuItem, IxMenuAbout, IxMenuSettings, IxContent } from '@siemens/ix-angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { AppVersion } from '../environments/app.version';
import { SettingsComponent } from "./core/settings/settings.component";
import { AboutInfoComponent } from './modules/about/about-info.component';
import { UserAuthComponent } from './core/auth/user-auth.component';
import { addIcons } from '@siemens/ix-icons';
import { 
  iconChevronRightSmall,
  iconClear,
  iconHome,
  iconLogIn,
  iconLogOut,
  iconSearch} from '@siemens/ix-icons/icons';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, IxApplication, IxApplicationHeader,
    IxMenu, IxMenuItem, IxMenuAbout, IxMenuSettings, IxContent, TranslateModule, SettingsComponent, AboutInfoComponent, RouterLink, UserAuthComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  translateService = inject(TranslateService);

  constructor() {
    addIcons({
      iconChevronRightSmall, iconLogIn, iconHome, iconLogOut, iconSearch, iconClear
  })
}

  applicationName = toSignal(this.translateService.get('APP.NAME').pipe(
    map(appName => AppVersion.flavor === "PRD" ? appName : `${appName} (${AppVersion.flavor})`)
  ), { initialValue: "APP.NAME" })
}
